import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { systemActions } from 'store/system/slices';

export const useGetNotifications = (): void => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(systemActions.externalNotifications.requestExternalNotifications());
  }, []);
};
